import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import {
  CardBody,
  Input,
} from "../../../../../../_metronic/_partials/controls";
import { getBankAll } from "../../../../MasterData/_redux/bank/bankCrud";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { getBankAccountAll } from "../../../../MasterData/_redux/bank-account/bankAccountCrud";

// Validation schema
const ImportMutationBankEditSchema = Yup.object().shape({
  name: Yup.string()
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Name wajb diisi"),
});

export function ImportMutationBankCreateForm({
  saveImportMutationBank,
  importMutationImportMutationBank,
  previewFile,
  bankAccount,
}) {
  useEffect(() => {
    getOptions();
  }, []);

  const [options, setOptions] = useState({
    bank: [],
    no_rek: [],
  });

  const getOptions = () => {
    getBankAll()
      .then((res) =>
        setOptions((prevState) => ({
          ...prevState,
          bank: res.data.data,
        }))
      )
      .catch((err) => console.log(err));
    getBankAccountAll()
      .then((res) =>
        setOptions((prevState) => ({
          ...prevState,
          no_rek: res.data.data,
        }))
      )
      .catch((err) => console.log(err));
  };

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={importMutationImportMutationBank}
        validationSchema={ImportMutationBankEditSchema}
        onSubmit={values => saveImportMutationBank(values)}
      >
        {({ handleSubmit, setFieldValue, values }) => (
          <>
            <Form className="form form-label-right">
              <div className="form-group row">
                <div className="col-lg-6">
                  {/* <label>Nama Bank</label> */}
                  <div className="d-flex">
                    <label htmlFor="channel_uuid">Nama Bank</label>
                    <a className="ml-2" href="/master-data/bank/list-bank">
                      (Tambah Bank)
                    </a>
                  </div>
                  <Autocomplete
                    name="bank"
                    options={options.bank}
                    getOptionLabel={option => option.name}
                    onChange={(e, value) => {
                      value
                        ? setFieldValue("bank", value.uuid)
                        : setFieldValue("bank", "");
                    }}
                    renderInput={params => (
                      <TextField
                        {...params}
                        placeholder="Pilih Bank"
                        variant="outlined"
                        disableClearable
                        size="small"
                      />
                    )}
                  />
                </div>
                <div className="col-lg-6">
                  {/* <label>No Rekening</label> */}
                  <div className="d-flex">
                    <label htmlFor="channel_uuid">Rekening Bank</label>
                    <a className="ml-2" href="/master-data/bank/account-bank">
                      (Tambah Rekening Bank)
                    </a>
                  </div>
                  <Autocomplete
                    name="no_rek"
                    options={options.no_rek.filter(
                      item => item.bank_uuid === values.bank
                    )}
                    getOptionLabel={option => option.account_number}
                    onChange={(e, value) => {
                      if (value) {
                        setFieldValue("no_rek", value.uuid);
                        bankAccount(value);
                      } else {
                        setFieldValue("no_rek", "");
                        bankAccount("");
                      }
                    }}
                    renderInput={params => (
                      <TextField
                        {...params}
                        placeholder="Pilih Bank"
                        variant="outlined"
                        disableClearable
                        size="small"
                      />
                    )}
                  />
                </div>
              </div>
              <div className="form-group row">
                <div className="col-lg-2">
                  <label>File Mutasi</label>
                </div>
                <div className="col-lg-4">
                  <input
                    type="file"
                    name="name"
                    placeholder="Text"
                    label="Name"
                    accept=".xlsx"
                    onChange={e => previewFile(e)}
                  />
                </div>
              </div>
            </Form>
          </>
        )}
      </Formik>
    </>
  );
}
